import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Flame, ShieldCheck } from 'lucide-react';
const phases = [{
  icon: Droplets,
  phase: 'Fase 1: Detox',
  title: 'Limpieza Profunda',
  description: 'Limpiar tu hígado de toxinas acumuladas que bloquean la pérdida de peso y causan inflamación.',
  color: 'bg-blue-50 text-blue-600'
}, {
  icon: Flame,
  phase: 'Fase 2: Reset',
  title: 'Reactivación Metabólica',
  description: 'Reeducar a tus células para que vuelvan a usar la grasa como fuente primaria de energía (y no solo el azúcar).',
  color: 'bg-orange-50 text-orange-600'
}, {
  icon: ShieldCheck,
  phase: 'Fase 3: Estabilización',
  title: 'Blindaje Hormonal',
  description: "Estabilizar tus resultados para que el 'efecto rebote' sea cosa del pasado y mantengas tu figura.",
  color: 'bg-green-50 text-green-600'
}];
export function SolutionSection() {
  return <section className="py-24 bg-[#faf8f5]" data-id="element-168">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-170">
          <span className="text-[#c9a227] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-171">
            La Solución Definitiva
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#1a4d3e] mb-6" data-id="element-172">
            El Protocolo Metabo-Reset 40+
          </h2>
          <p className="text-lg text-gray-600" data-id="element-173">
            No es una dieta restrictiva. Es un manual de instrucciones para tu
            nueva biología. Un sistema de 3 fases diseñado específicamente para
            el cuerpo de la mujer latina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-174">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-200 -z-10 transform translate-y-1/2" data-id="element-175"></div>

          {phases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative" data-id="element-176">
              <div className={`w-16 h-16 ${item.color} rounded-2xl flex items-center justify-center mb-6 text-3xl mx-auto md:mx-0 shadow-sm`} data-id="element-177">
                <item.icon size={32} data-id="element-178" />
              </div>

              <div className="text-center md:text-left" data-id="element-179">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1 block" data-id="element-180">
                  {item.phase}
                </span>
                <h3 className="text-xl font-bold text-[#1a4d3e] mb-3" data-id="element-181">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-182">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-183">
          <p className="text-xl font-serif italic text-[#1a4d3e] mb-2" data-id="element-184">
            "En solo 21 días, sentirás que has retrocedido el reloj biológico."
          </p>
        </div>
      </div>
    </section>;
}